module.exports = __webpack_public_path__ + "87760c65c430d4cf742f6cf9a9325cb1.svg";